import { useEffect, useState } from "react";

/**
 * Real browser connectivity, via navigator.onLine plus the online/offline
 * events - nothing in the app read either of these before this hook. Note
 * navigator.onLine only reflects network-adapter state (e.g. flight mode,
 * no wifi/cellular radio) - it can still read `true` when there's a radio
 * connection but no actual route to the server (captive portal, server
 * down). It's a useful fast signal, not a guarantee of reachability.
 */
export function useOnlineStatus(): boolean {
  const [isOnline, setIsOnline] = useState<boolean>(
    typeof navigator === "undefined" ? true : navigator.onLine,
  );

  useEffect(() => {
    const goOnline = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  return isOnline;
}
